import React from 'react';

export const LabelControl = ({field, formDataEntry} : ControlParameters) : JSX.Element => {

  if(formDataEntry && !formDataEntry.enabled) {
    return (null);
  }
  
  return (
    <div className="form-group">
      <span className={`form-control-plaintext ${field?.properties?.fieldcssclass}`} id={field['@column']}>
        {field?.properties?.fieldcaption}
      </span>
    </div>
  );
};